import Koppa from "@koppajs/koppajs-core";

import dialogComponent from './dialog-component.kpa';
Koppa.take(dialogComponent, 'dialog-component');

class Dialog {
    public name = "dialog";
    private debug = false;

    private initialized = false;

    private dialogs: HTMLDivElement[] = [];
    private dialogContainer: HTMLDivElement | null = null;

    constructor() {
        
    }

    private logDebug(...args: any[]): void {
        if (this.debug) {
            console.log(`[${this.name} Debug]:`, ...args);
        }
    }

    public init(): void {
        if (this.initialized) {
            console.warn("DialogManager is already initialized.");
            return;
        }
        this.initialized = true;
    
        this.logDebug("Initializing dialog manager...");
        const dialogOverlay = document.querySelector("dialog-component .dialog-overlay");
        if (dialogOverlay) {
            this.dialogContainer = dialogOverlay as HTMLDivElement;
        } else {
            console.error("No dialog-overlay found. Ensure dialog-component is mounted.");
        }
    }

    public createDialog(
        content: string,
        type: 'simple' | 'confirmation' | 'modal',
        options: { onConfirm?: () => void; onCancel?: () => void } = {}
    ): void {
        console.log(`Creating dialog of type: ${type} with content: ${content}`);
        
        if (!this.dialogContainer) {
            console.error("Dialog container not initialized.");
            return;
        }
    
        const dialog = document.createElement("div");
        dialog.className = `dialog dialog-${type}`;

        if(type === 'confirmation') {
            dialog.innerHTML = `
                <div class="dialog-box">
                    <div class="dialog-content">${content}</div>
                    <div class="dialog-actions">
                        <button class="dialog-confirm">Confirm</button><button class="dialog-cancel">Cancel</button>
                    </div>
                </div>
            `;
        }

        if(type === 'simple') {
            dialog.innerHTML = `
                <div class="dialog-box">
                    <div class="dialog-content">${content}</div>
                    <div class="dialog-actions">
                        <button class="dialog-close">Close</button>
                    </div>
                </div>
            `;
        }

        if(type === 'modal') {
            dialog.innerHTML = `
                <div class="dialog-outside-close"></div>
                <div class="dialog-box">
                    <div class="dialog-content">${content}</div>
                    <div class="dialog-close box-shadow"><i class="fa-solid fa-xmark"></i></div>
                </div>
            `;
        }
    
        // Event-Listener hinzufügen basierend auf dem Typ
        if (type === "confirmation") {
            dialog.querySelector(".dialog-confirm")?.addEventListener("click", () => {
                options.onConfirm?.();
                this.closeDialog(dialog);
            });
            dialog.querySelector(".dialog-cancel")?.addEventListener("click", () => {
                options.onCancel?.();
                this.closeDialog(dialog);
            });
        } else if (type === "simple") {
            dialog.querySelector(".dialog-close")?.addEventListener("click", () => {
                this.closeDialog(dialog);
            });
        } else if (type === "modal") {
            dialog.querySelector(".dialog-outside-close")?.addEventListener("click", () => {
                this.closeDialog(dialog);
            });

            dialog.querySelector(".dialog-close")?.addEventListener("click", () => {
                this.closeDialog(dialog);
            });
        }

        // Breite des Scrollbalkens berechnen
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

        // Scrollbalken ausblenden
        document.body.style.overflow = 'hidden';

        // Padding hinzufügen, um den fehlenden Scrollbalken auszugleichen
        document.body.style.paddingRight = `${scrollbarWidth}px`;
    
        this.dialogContainer.appendChild(dialog);
        this.dialogs.push(dialog);
    }

    public closeDialog(dialog: HTMLDivElement): void {
        dialog.remove();
        this.dialogs = this.dialogs.filter((d) => d !== dialog);

        // Scrollbalken wieder aktivieren
        document.body.style.overflow = '';

        // Padding zurücksetzen
        document.body.style.paddingRight = '';
    }

    public closeAllDialogs(): void {
        this.dialogs.forEach((dialog) => dialog.remove());
        this.dialogs = [];

        // Scrollbalken wieder aktivieren
        document.body.style.overflow = '';

        // Padding zurücksetzen
        document.body.style.paddingRight = '';
    }
}

export default new Dialog();